import styled from "styled-components";

export default function JardimDeAlah(){
    return(
        <Content>
            <h1>Veja porque apoiamos a Concessão do Jardim de Alah!</h1>

            <iframe width="1013" height="570" src="https://www.youtube.com/embed/cr7j2kRfH3A" title="SIM CONCESSÃO JARDIM DE ALAH APOIADORES" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            <Texto>
                <h1>VOCÊ SABE O QUE É UMA PARCERIA PÚBLICO-PRIVADA?</h1>
                <h3>Conceito de Parceria Público-Privada (PPP)</h3>

                <p>
                    Afinal, a conceituação dessa modalidade contratual parece ser simples, mas não é bem assim.
                    Pelo senso comum, o conceito de PPP pode ser entendido como qualquer relação entre o poder
                    público e a iniciativa privada. Podemos adotar como definição ampla a seguinte:
                </p>

                <p>
                    <strong>Definição ampla empregada no Guia de PPPs:</strong>
                    Segundo o Guia CP3P, criado pelo Banco Mundial e outros bancos de desenvolvimento, esse tipo
                    de contrato pressupõe um projeto de infraestrutura que faz uso intensivo de capital e que
                    depende de financiamento do setor privado.
                </p>

                <h2>A AMAI DIZ SIM À CONCESSÃO DO JARDIM DE ALAH</h2>
                <p class="site">www.ipanema.org.br</p>

                <h3>Alguns dos pontos que a AMAI defende na concessão:</h3>
                <ul>
                    <li>Situação atual de penúria, insegurança e abandono, que não pode continuar;</li>
                    <li>
                        O Jardim de Alah deve atender aos moradores, entre os quais, com muito carinho,
                        a Cruzada São Sebastião, além dos frequentadores;
                    </li>
                    <li>
                        <strong>a-</strong> Quadras de esportes para os moradores do bairro e para as escolinhas da Cruzada;
                    </li>
                    <li>
                        <strong>b-</strong> Creche recuperada ou reconstruída para as mães da Cruzada que precisam trabalhar
                        fora e não têm onde deixar os pequenos.
                    </li>
                </ul>

                <p class="destaque">TEMOS DE TER SEGURANÇA (segurança privada 24h).</p>

                <h3>Parceria Público-Privada:</h3>
                <ul>
                    <li>Recuperação completa;</li>
                    <li>Melhorias;</li>
                    <li>Manutenção pela iniciativa privada;</li>
                    <li>Segurança 24h.</li>
                </ul>

                <h3>Ganham todos e a cidade:</h3>
                <ul>
                    <li>Novo polo de atração turística;</li>
                    <li>Fomento da rede hoteleira;</li>
                    <li>Fomento do comércio;</li>
                    <li>Ipanema volta ao cenário de importância histórica que sempre teve.</li>
                </ul>

                <h3>Precauções e trabalho na concessão:</h3>
                <ul>
                    <li>Estudos de impacto ambiental;</li>
                    <li>Estudos de impacto sonoro e regras para volume de som em pequenos eventos;</li>
                    <li>Proibição de arenas de show e grandes eventos;</li>
                    <li>Estudo de impacto no trânsito;</li>
                    <li>Tentar recuperar/replantar as árvores retiradas na obra do metrô;</li>
                    <li>
                        Não perder área verde e de jardins do parque, mantendo as características paisagísticas.
                    </li>
                </ul>

                <h3>Parcão dos Pets:</h3>
                <ul>
                    <li>Não perder o tamanho e manter a área atual do parcão;</li>
                    <li>
                        Conversar com o ganhador da concessão sobre eventuais melhorias no parcão,
                        como parte da área com cobertura para dias de chuva;
                    </li>
                    <li>Colocação de bebedouros para os pets.</li>
                </ul>

                <p class="emoji">
                    😎 <strong>Criação de um Comitê Comunitário</strong>, com assento de um representante de cada
                    uma das associações existentes em Ipanema e no Leblon, para acompanhar as obras e atuar
                    durante a concessão, funcionando como um condomínio junto ao concessionário vencedor.
                </p>

            </Texto>
        </Content>
    )
}

const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    font-family: 'Poppins', sans-serif;

    h1, h2, h3 {
        color: #212529;
    }

    h1{
        font-size: 2rem;
        font-weight: bold;
        margin: 20px 0;
    }
`

const Texto = styled.div`
    width: 70%;
    
    h1 {
        font-size: 1.8rem;
    }
    h2 {
        margin-top: 30px;
        font-size: 1.4rem;
    }
    h3 {
        margin-top: 20px;
        font-size: 1.2rem;
    }
    ul {
        margin-left: 20px;
    }
    li {
        margin-bottom: 8px;
    }
    .destaque {
        font-weight: bold;
    }
    .site {
        margin-top: 10px;
        font-weight: bold;
    }
    .emoji {
        font-size: 1.1rem;
    }
`